module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('a', {
    staticClass: "notifications-read-all border-1-20",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markAllNotificationsAsRead()
      }
    }
  }, [_c('span', {
    staticClass: "notifications-read-all-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.163 9.729"
    },
    attrs: {
      "version": "1.1",
      "id": "icons",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.163 9.729",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    staticClass: "st0",
    attrs: {
      "points": "10.394,0 4.841,6.109 1.768,3.035 0,4.804 4.927,9.729 12.163,1.77 "
    }
  })])]), _vm._v("\n        Mark all as read")]), _vm._v(" "), _c('div', {
    staticClass: "notifications-list"
  }, _vm._l((_vm.notifications), function(item, index) {
    return _c('div', {
      staticClass: "notifications-group"
    }, [_c('div', {
      staticClass: "item-date",
      class: [{
        'unread': item.unread
      }]
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('div', _vm._l((item.children), function(child) {
      return _c('div', {
        staticClass: "notifications-item",
        class: [{
          'unread': !child.isRead
        }]
      }, [_c('div', {
        staticClass: "item-time"
      }, [_vm._v(_vm._s(child.time))]), _vm._v(" "), _c('div', {
        staticClass: "item-details",
        on: {
          "click": function($event) {
            return _vm.readNotification(child)
          }
        }
      }, [(child.type === 1) ? [(child.contentId && child.companyId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 2 || child.type === 3) ? [(child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'edit-user',
            params: {
              id: child.userFromId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e(), _vm._v(" "), (!child.userFromId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'consent-logs'
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 4) ? [(child.contentId) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'content',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _vm._e()] : (child.type === 5) ? [(_vm.getUserRole === 'gm') ? _c('router-link', {
        attrs: {
          "to": {
            name: 'company-task',
            params: {
              companyId: child.companyId,
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))]) : _c('router-link', {
        attrs: {
          "to": {
            name: 'task',
            params: {
              id: child.contentId
            }
          }
        }
      }, [_vm._v(_vm._s(child.message))])] : [_vm._v("\n                  " + _vm._s(child.message) + "\n                ")]], 2)])
    }), 0)])
  }), 0), _vm._v(" "), (_vm.loadedCount < _vm.allCount) ? _c('div', {
    staticClass: "notifications-load-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore()
      }
    }
  }, [_vm._v("Load more")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3639c3c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Notifications.vue
// module id = 912
// module chunks = 1